import { render } from "./PremiumPage.vue?vue&type=template&id=a582fed4"
import script from "./PremiumPage.vue?vue&type=script&lang=js"
export * from "./PremiumPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__